import { ExtendedCellProps } from './scenario-planner-details-table.component';

export const ScenarioPlannerInputCellReadOnlyComponent = ({
  data,
  col,
  inputTypeOptions,
}: ExtendedCellProps) => {
  const inputTypeField = `${col.idField}_INPUT_TYPE_ID`;
  const inputField = `${col.idField}_INPUT`;
  const value = data[inputField] === null ? '' : data[inputField];
  const changeTypeValue =
    data[inputTypeField] === null ? 'perc' : data[inputTypeField];

  return (
    <div className={`scenario-planner-input-cell ${col.id}`}>
      <input
        type="number"
        className="form-control change-input"
        value={value}
        placeholder="N/A"
        disabled={true}
      />
      <div
        className={`change-type disabled ${value ? 'select-has-value' : ''}`}
      >
        {inputTypeOptions?.find((i) => i.value === changeTypeValue)?.label}
      </div>
    </div>
  );
};
